export default __webpack_public_path__ + "static/media/category-icon-Events.c8a9b35b.svg";